/**
 * Initialize all installers on the application, in order of priority.
 * The installers are loaded from the `src/core/config` directory.
 *
 * TODO: Add support for dependencies
 * @param {Vue.js Application} app
 */
export async function initializeInstallers(app) {
  const installers = import.meta.glob('./*.installer.js', { eager: true })

  const sortedInstallers = Object.entries(installers)
    .map(([key, module]) => ({
      key,
      module,
      priority: module.priority || 100,
    }))
    .sort((a, b) => a.priority - b.priority)

  for (const { module } of sortedInstallers) {
    if (module.install) {
      await module.install({ app })
    }
  }
}
